import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ScrollFadeDirective } from '@cosmos/angular/utils';
import { HtmlLegendItem } from './chartjs-plugin-html-legend';

/**
 * Renders a chart's legend as real Angular DOM instead of Chart.js's on-canvas
 * legend — fixes the font-mismatch (canvas legend can't use the app's real
 * typography) and the unbounded-height problem (many datasets, e.g. SHM's up
 * to 8 channels or compare-measurements' open-ended series count, could push
 * the canvas legend to eat most of the card, squeezing the plot itself down
 * to a sliver).
 *
 * Dumb/presentational: takes the current legend items (from
 * HtmlLegendPlugin's callback) and emits which dataset was clicked — the
 * host chart component owns actually calling chart.setDatasetVisibility()
 * + chart.update(), same division of responsibility as
 * ChartOptionsButtonComponent (configChange) / MultiLineChartComponent.
 */
@Component({
  selector: 'cosmos-chart-legend',
  imports: [ScrollFadeDirective],
  templateUrl: './chart-legend.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChartLegendComponent {
  readonly items = input<HtmlLegendItem[]>([]);

  /** Emits the datasetIndex of the clicked legend item — host toggles visibility. */
  readonly toggle = output<number>();
}
